import React from 'react';
import { useBwicTableContext } from '@/creditflowresearch/application/Bonds/BwicTableContext';
import { useInventoryTableContext } from '@/creditflowresearch/application/Bonds/InventoryTableContext';
import BaseAssetClasses from '@/creditflowresearch/ui/components/bonds/common/AssetClasses/BaseAssetClasses';
import { IAssetClass } from '@/creditflowresearch/domain/vo/IAssetClass';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import useGetBondsPayload from '@/creditflowresearch/application/Bonds/useGetBondsPayload';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';

const AssetClassesContainer = () => {
  const { isBwicFetching, getBwics } = useBwicTableContext();
  const {
    isInventoriesFetching,
    getInventories,
  } = useInventoryTableContext();
  const isCollectionsFetching = isBwicFetching || isInventoriesFetching;

  const { assetsClasses, handleAssetClassClick } = useBondsAssetClassesContext();
  const { plan } = useUserPlanContext();
  const { handlePageChange } = useFiltersContext();

  const isAllDisabled = isCollectionsFetching || plan !== UserPlanType.PRO;

  const { getPayload } = useGetBondsPayload();

  const onClick = (assetClass: IAssetClass) => {
    handleAssetClassClick(assetClass);
    handlePageChange(1);
    const payload = getPayload({ assetClassId: assetClass.id });
    getBwics(payload);
    getInventories(payload);
  };

  return (
    <BaseAssetClasses
      assetClassCollection={ assetsClasses }
      isAllDisabled={ isAllDisabled }
      handleAssetClassClick={ onClick }
    />
  );
};

export default AssetClassesContainer;
